// extracted by mini-css-extract-plugin
module.exports = {"msnbcDailyBorder":"msnbcDailyBorder___2ksXF"};